import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SocialLearningService } from 'src/app/_services';
import { SocialLearningPostGet } from 'src/app/_models';
import { environment } from 'src/environments/environment';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-post-viewer-like-view',
  templateUrl: './post-viewer-like-view.component.html',
  styleUrls: ['./post-viewer-like-view.component.scss']
})
export class PostViewerLikeViewComponent extends BaseComponent implements OnInit {
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    suppressScrollY: false
  };
  @Input()
  postItemId: number = null;
  @Input()
  isView: boolean = false;
  headerName: string = 'Likes';
  likesAndViews: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  isLoading = false;
  pageSize: number = 10;
  pageIndex: number = 1;
  @ViewChild(PerfectScrollbarDirective)
  directiveRef?: PerfectScrollbarDirective;
  url: string = environment.apiUrl;
  constructor(private modalRef: BsModalRef, private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {
    this.modalInit();
  }
  modalInit(): void {
    if (this.isView) {
      this.headerName = 'Views';
      this.getViews();
    } else this.getLikes();
  }
  getViews(): void {
    this.isLoading = true;
    this.socialLearningService.GetViews(this.postItemId, this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        if (this.pageIndex === 1) this.likesAndViews = data;
        else {
          data.results.map(item => {
            this.likesAndViews.results.push(item);
          });
          this.likesAndViews.totalRecords = data.totalRecords;
        }
        this.isLoading = false;
      },
      () => (this.isLoading = false)
    );
  }
  getLikes(): void {
    this.isLoading = true;
    this.socialLearningService.GetLikes(this.postItemId, this.pageSize, this.pageIndex).subscribe(
      (data: SocialLearningPostGet) => {
        if (this.pageIndex === 1) this.likesAndViews = data;
        else {
          data.results.map(item => {
            this.likesAndViews.results.push(item);
          });
          this.likesAndViews.totalRecords = data.totalRecords;
        }
        this.isLoading = false;
      },
      () => (this.isLoading = false)
    );
  }
  getAuthorImageUrl(imageUrl: string): string {
    return imageUrl ? this.getImage(imageUrl) : '../../assets/Images/users/default-user.jpg';
  }
  // onScroll(): void {
  //   const pos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
  //   const max = document.documentElement.scrollHeight;
  //   if (pos === max) {
  //     if (this.posts.results.length < this.posts.totalRecords) {
  //       this.pageIndex += 1;
  //       this.getPosts();
  //     }
  //   }
  // }
  onScroll(): void {
    if (this.likesAndViews.totalRecords > this.likesAndViews.results.length) {
      const position = this.directiveRef.geometry().y + this.directiveRef.geometry().w;
      if (position === this.directiveRef.geometry().h) {
        this.pageIndex += 1;
        if (this.isView) this.getViews();
        else this.getLikes();
      }
    }
  }
  modalClose() {
    this.modalRef.hide();
  }
}
